import React, {Component} from 'react'
import '@/assets/styles/contact.scss'


import ContactBanner from '@/assets/images/contact-banner.png'
import ContactBannerMobile from '@/assets/images/contact-banner-mobile1.png'
export default class Contact extends Component {
    state = {
        time: new Date().toTimeString().slice(0,8),
        date: new Date().toDateString()
    }

    componentDidMount() {  
        this.tick()
      }
    
    componentWillUnmount() {  
        clearTimeout(this.timer)
    }


    tick = () => {                  
        this.timer = setInterval(()=> {  
            this.setState({ 
                time: new Date().toTimeString().slice(0,8)
            })
        }, 1000)
    }

    render() {
       const { time, date } = this.state
        return (
            <div className="contact-page">
               <img className='hidden-xs' src={ContactBanner} alt="" />
               <img className='visible-xs' src={ContactBannerMobile} alt="" />
               {/* <div className='time'>
                <p>{ time }</p>
                <p>{ date }</p>
               </div> */}
            </div>
        )
    }
}